import { useCallback } from 'react'

import { useMutation } from '@apollo/client'
import { ApolloCache, DefaultContext, MutationUpdaterFunction } from '@apollo/client'
import {
  NotificationsCountInboxNotificationsDocument,
  NotificationsMarkAsReadInboxNotificationDocument,
} from 'generated/resources/graphql'

const cacheUpdater: MutationUpdaterFunction<
  unknown,
  unknown,
  DefaultContext,
  ApolloCache<unknown>
> = (cache, {}) => {
  cache.writeQuery({
    query: NotificationsCountInboxNotificationsDocument,
    variables: {
      onlyUnread: true,
    },
    data: {
      notifications: {
        inboxNotificationsConnection: {
          totalCount: 0,
        },
      },
    },
  })
}

export const useNotificationsMarkAsRead = () => {
  const [notificationsMarkAsRead, { loading }] = useMutation(
    NotificationsMarkAsReadInboxNotificationDocument,
    {
      update: cacheUpdater,
    }
  )

  const update = useCallback(
    async (sinceId: number) => {
      const result = await notificationsMarkAsRead({ variables: { sinceId } })
      return result
    },
    [notificationsMarkAsRead]
  )

  return {
    updating: loading,
    update,
  }
}
